import type { QueryKey } from "@tanstack/react-query";
import { auditKeys } from "@amber/access/ui";
import { operationsKeys } from "@amber/operations/ui";
import { profileKeys } from "@amber/profiles/ui";

export const collectionKeys = {
  all: ["collection"],
  items: (params: unknown) => ["collection", "items", params] as const,
  item: (id: string) => ["collection", "item", id] as const,
  urlCheck: (url: string) => ["collection", "url-check", url] as const,
  recoveryPreview: (request: unknown) => ["collection", "recovery-preview", request] as const,
  routes: ["collection", "routes"],
  quarantinePreview: (id: string) => ["collection", "routes", id, "quarantine-preview"] as const,
  releasePreview: (id: string) => ["collection", "routes", id, "release-preview"] as const,
  deleted: (tab: string) => ["collection", "deleted", tab] as const,
  accessPreview: (id: string, target: string) => ["collection", "access-preview", id, target] as const,
  sources: (search: unknown) => ["collection", "sources", search] as const,
  source: (id: string) => ["collection", "source", id] as const,
  sourceEdit: (id: string) => ["collection", "source-edit", id] as const,
  sourceValue: (id: string) => ["collection", "source-value", id] as const,
  sourceValues: ["collection", "source-values"],
  sourceBulkPreview: (request: unknown) => ["collection", "source-bulk-preview", request] as const,
  sourceOptions: ["collection", "source-options"],
  sourcePlan: (id: string) => ["collection", "source-plan", id] as const,
  planPreview: (request: unknown) => ["collection", "plan-preview", request] as const,
  backfillPreview: (gapId: string) => ["collection", "backfill-preview", gapId] as const,
  history: ["collection", "history"],
  extensionPreview: (target: string) => ["collection", "extension-preview", target] as const,
} as const;

export const AFTER_COLLECTION_CHANGE: readonly QueryKey[] = [collectionKeys.all, auditKeys.all, operationsKeys.all];
export const ON_COLLECTION_CONFLICT: readonly QueryKey[] = [collectionKeys.all];

export const AFTER_PLAN_CHANGE: readonly QueryKey[] = [collectionKeys.all, profileKeys.all, auditKeys.all];
export const ON_PLAN_CONFLICT: readonly QueryKey[] = [collectionKeys.all, profileKeys.all];
